// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"DQ-z","categoryName":"EQ-z","categoryNameSearchHeader":"FQ-z","categoryContent":"GQ-z","bottomAligned":"HQ-z","image":"IQ-z","imageNoBackground":"JQ-z"};